<nz-tag *ngIf="bid.needPriorityPass" [nzColor]="'gold'">
  {{ 'LOT_BIDDING_MODAL.PRIORITY_PASS' | translate }}
</nz-tag>
